import { ScreenMessage } from '@features/common';
import WelcomeCustomersImage from '@assets/WelcomeCustomers.svg';
import { SEARCH_CONTAINER_HEIGHT } from '../constants/search.constants';

const WelcomeToCustomers: React.FC = () => (
	<ScreenMessage
		fullHeight
		fullWidth
		alt="Hombre cruzando los brazos"
		description="Realiza una búsqueda para obtener información de tu cliente"
		id="welcome-to-customers"
		image={WelcomeCustomersImage}
		imageHeight={427}
		imageWidth={406}
		style={{
			height: 'auto',
			minHeight: `calc(100vh - ${SEARCH_CONTAINER_HEIGHT})`,
			padding: '2rem 1rem',
		}}
		title="¡Te damos la bienvenida al módulo Clientes!"
	/>
);

export default WelcomeToCustomers;
